import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import * as React from 'react'

type Props = {
  member: IDamageItem
}

const stageColor: { [key in IDamageInfoStage]: string } = {
  processing: 'blue',
  pending: 'blue',
  finalizing: 'green',
  finalized: 'green'
}

const DamageStageTag: React.FC<Props> = ({ member }) => {
  const { tAttribute } = useTranslation({ recordType: RecordType.damage_info })
  const damageInfo = member.damage_info
  const text = damageInfo.damage_stage
    ? tAttribute({ id: `damage_stage_options.${damageInfo.damage_stage}` })
    : '-'

  return <KTag text={text} color={stageColor[damageInfo.damage_stage]} />
}

export default DamageStageTag
